module.exports = __webpack_public_path__ + "static/sorrowful_0-c98f96b7c8d05939d74152656021dfbc.png";